import BoxWithGutter from "./BoxWithGutter";
import PromoBlock from "./PromoBlock";
import PropTypes from "prop-types";
import { RIGHT } from "../core/constants";
import React from "react";

function HomepagePromoArea({
  data: { promoTitle, promoText, promoImage, ctaLink, ctaButtonText },
}) {
  const image = {
    src: promoImage.url,
    alt: promoImage.title,
  };

  return (
    <BoxWithGutter my={[30, null, 80, null]}>
      <PromoBlock
        heading={promoTitle}
        text={promoText}
        image={image}
        imagePos={RIGHT}
        ctaLink={ctaLink}
        ctaText={ctaButtonText}
        externalLink
      />
    </BoxWithGutter>
  );
}

export default HomepagePromoArea;

HomepagePromoArea.propTypes = {
  data: PropTypes.shape({
    promoTitle: PropTypes.string.isRequired,
    promoText: PropTypes.string.isRequired,
    promoImage: PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }).isRequired,
    ctaLink: PropTypes.string,
    ctaButtonText: PropTypes.string,
  }).isRequired,
};
